import React from "react";
import { Card, Descriptions, Empty, Badge, Progress, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { CrownOutlined } from "@ant-design/icons";
import { useFormatos } from "../../../../i18n/formatos";

const { Title } = Typography;

export function InstitutionPlanCard({ plan, expiry }) {
  const { t } = useTranslation(["institution", "common"]);
  // La fecha sigue al idioma de la interfaz, no al del navegador.
  const { fecha } = useFormatos();

  if (!plan) {
    return (
      <Card variant="outlined" style={{ height: "100%" }}>
        <Empty description={t("profile.plan.empty")} />
      </Card>
    );
  }

  // Calculamos días restantes (ejemplo visual)
  const daysLeft = expiry
    ? Math.ceil((new Date(expiry) - new Date()) / (1000 * 60 * 60 * 24))
    : 0;
  const percent = Math.max(0, Math.min(100, (daysLeft / 365) * 100)); // Aproximado

  return (
    <Card
      variant="outlined"
      style={{
        height: "100%",
        background: "linear-gradient(135deg, #ffffff 0%, #f9f9f9 100%)",
      }}
      title={
        <>
          <CrownOutlined style={{ color: "#faad14" }} />{" "}
          {t("profile.plan.title")}
        </>
      }
      extra={<Badge status="processing" text={t("profile.plan.badge")} />}
    >
      <div style={{ textAlign: "center", marginBottom: 24 }}>
        <Title level={3} style={{ marginBottom: 0 }}>
          {plan.title}
        </Title>
        {/*
          El tipo de cuenta va DENTRO de la frase: en frances el orden es
          "Licence {{tipo}}", al reves que aqui.
        */}
        <Typography.Text type="secondary">
          {t("profile.plan.licenseOf", { tipo: plan.account })}
        </Typography.Text>
      </div>

      <div style={{ marginBottom: 24 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 4,
          }}
        >
          <span>{t("profile.plan.validity")}</span>
          {/* Contador: en frances "1 jour restant" y el cero tambien singular. */}
          <span>
            {daysLeft > 0
              ? t("common:contadores.diasRestantes", { count: daysLeft })
              : t("profile.plan.expired")}
          </span>
        </div>
        <Progress
          percent={percent}
          showInfo={false}
          status={daysLeft > 0 ? "active" : "exception"}
        />
        <div
          style={{
            textAlign: "right",
            fontSize: 12,
            marginTop: 4,
            color: "#999",
          }}
        >
          {t("profile.plan.expiresLabel")}{" "}
          {expiry ? fecha(expiry) : t("profile.plan.noExpiry")}
        </div>
      </div>

      <Descriptions column={1} size="small">
        <Descriptions.Item label={t("profile.plan.vrDevices")}>
          <b>{plan.vrHeadsetNumber}x</b> {plan.vrHeadsetModel}
        </Descriptions.Item>
        <Descriptions.Item label={t("profile.plan.trainingIncluded")}>
          {plan.curseBasic ? t("profile.plan.yes") : t("profile.plan.no")}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
}
